import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import MoorepayLogo from '../../assets/images/moorepay-logo-white.png';

function MoorepayBanner({
  hiddenFilters,
}) {
  let location = useLocation();

  if (hiddenFilters.findIndex(filter => location.pathname.includes(filter)) >= 0) {
    return null
  }

  return (
    <div className="bg-gradient-to-b from-moorepay-pacific to-moorepay-prussian">
      <div className="max-w-screen-xl mx-auto flex flex-col items-center gap-y-3 px-4 py-8 text-center sm:flex-row sm:justify-between sm:gap-x-8 sm:px-6 sm:py-7 sm:text-left">
        <p className="text-sm text-white sm:text-base">
          <span className="text-base font-semibold sm:text-lg">Buddy is now part of Moorepay.</span>
          <span aria-hidden="true" className="hidden px-3 text-white text-opacity-40 sm:inline">|</span>
          <span className="block text-white text-opacity-90 sm:inline">
            Same software. Same team. Simply a new name and updated branding inside your products.
          </span>
        </p>
        <img
          className="h-8 w-auto flex-shrink-0"
          src={MoorepayLogo}
          alt="Moorepay"
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    hiddenFilters: state.navBarOverride.hide,
  }
}

export default connect(mapStateToProps)(MoorepayBanner)
